import create from 'zustand'
import store from '../store'
import { useEffect } from 'react'
import { State } from '../store/types'
import useAxiosRequest from './useAxiosRequest'

const useDiscoverNetwork = () => {
  const axios = useAxiosRequest({})

  const useStore = create<State>(store)

  const { target, networkSlug, networkId, setNetworkId } = useStore()

  const getNetwork = async (slug) => {
    const response = await axios({ endpoint: `/networks/${slug}` })

    return setNetworkId(response?.data?.id)
  }

  useEffect(() => {
    if (!!target && !!networkSlug && !networkId) {
      getNetwork(networkSlug)
    }
  }, [target, networkSlug, networkId])
}

export default useDiscoverNetwork
